import { IPmCanceledReason } from '../../../APIPackage/CatalogsModule/interfaces/IPmCanceledReason';
import { IPmCanceledReasonSelectOption } from '../interfaces/IPmCanceledReasonSelectOption';

export function createPmCanceledReasonSelectOption(reason: IPmCanceledReason): IPmCanceledReasonSelectOption {
  return {
    ...reason,
    label: reason.name,
    value: reason.id,
  };
}
